import { ChakraProvider } from '@chakra-ui/react'

import store from '@core/app/store/store'
import { IsApplyDialogProvider } from '@core/utils/contexts/ApplyDialogContext/ApplDialogContext'
import { ModalProvider } from '@core/utils/contexts/ModalContext/ModalContextProvider'
import { ThemeProvider } from '@core/utils/contexts/ThemeContext/ThemeContext'
import ErrorBoundary from '@core/utils/helpers/errorBoundary'

import '@core/utils/i18n'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import '../../index.css'
import { initSentry } from '@core/utils/sentry/initSentry'

import { PolicyPage } from './PolicyPage'
import theme from '../../theme'

import * as Sentry from '@sentry/react'

initSentry()

const router = createBrowserRouter([
    {
        path: process.env.ENV === 'local' ? '' : '/privacy-policy',
        element: (
            <ErrorBoundary fallback={<div>Something went wrong...</div>}>
                <ThemeProvider>
                    <IsApplyDialogProvider>
                        <PolicyPage />
                    </IsApplyDialogProvider>
                </ThemeProvider>
            </ErrorBoundary>
        ),
    },
])

const app = document.getElementById('root')
const root = createRoot(app!)
root.render(
    <>
        <Provider store={store}>
            <ChakraProvider theme={theme}>
                <ModalProvider>
                    <RouterProvider router={router} />
                </ModalProvider>
            </ChakraProvider>
        </Provider>
    </>
)
